class RemoveOrganizationLogo {
	constructor(public readonly organizationId: number) {
		Object.freeze(this);
	}
}

export default RemoveOrganizationLogo;
